<script>
import { Bar } from "vue-chartjs"
import _COLORS from "@/store/_COLORS"

export default {
  extends: Bar,
  props: {
    data: Array,
    labels: Array,
    label: String,
    title: String,
    unidade: {
      default: "unidades",
      type: String
    },
    step: {
      default: 0,
      type: Number
    }
  },
  mounted() {
    const COLORS = this.data
      .map(el => {
        return _COLORS[Math.floor(Math.random() * _COLORS.length)]
      })
      .sort(() => {
        return Math.random()
      })

    this.renderChart(
      {
        labels: this.labels,
        datasets: [
          {
            label: this.label.toUpperCase(),
            data: this.data,
            backgroundColor: this.data.map((el, idx) => {
              return COLORS[idx] + "4D"
            }),
            borderColor: this.data.map((el, idx) => {
              return COLORS[idx] + "99"
            }),
            borderWidth: 1,
            borderAlign: "outter"
          }
        ]
      },
      {
        responsive: true,
        maintainAspectRatio: false,
        title: {
          display: true,
          text: this.title.toUpperCase(),
          fontSize: 14
        },
        scales: {
          yAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: "Valores em " + this.unidade
              },
              ticks: {
                beginAtZero: true,
                stepSize: this.step
              }
            }
          ]
        }
      }
    )
  }
}
</script>
